import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import './Holidays.css';
import HolidayCard from './HolidayCard';
import {
  deleteHolidayById,
  getHolidays,
  updateHolidayById,
} from '../../../Services/MasterdataService';
import moment from 'moment';
import GenericLoader from '../../../../components/Loader/GenericLoader';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { DialogBoxComponent } from '../../../../components/DialogBox/DialogBoxCard';
import AddHoliday from './AddHoliday';
import { useDispatch } from 'react-redux';
import {
  HolidaysComponentLoaderAttribute,
  SHOW_NOTIFICATION,
} from '../../../../constants';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { ADMIN_PATH } from '../../../../url';

import HttpService from '../../../../services/HttpService';

function HolidaysComponent() {
  const _axios = HttpService.getAxiosClient();
  const [loader, setLoader] = React.useState(false);
  const [holidayTitle, setTitle] = React.useState('');
  const [date, setDate] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const [showError, setShowError] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState();
  const [holidaysList, setHolidaysList] = React.useState([]);
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const loadData = async (locationId) => {
    setHolidaysList([]);
    const response = await getHolidays(locationId);
    setLoader(true);
    if (response.isError === false) {
      if (response.data && response.data.length > 0) {
        setHolidaysList(groupDataByYear(response.data));
      } else {
        setHolidaysList([]); // Set empty array if no data
      }
      setLoader(false);
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchOfficeLocation();
  }, []);

  const groupDataByYear = (data) => {
    const groupedData = [];

    data.forEach((item) => {
      const year = new Date(item.date + 'T00:00:00').getFullYear();
      const existingYearIndex = groupedData.findIndex(
        (group) => group.year === year,
      );

      if (existingYearIndex !== -1) {
        groupedData[existingYearIndex].data.push(item);
      } else {
        groupedData.push({ year, data: [item] });
      }
    });

    return groupedData;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const updateHoliday = async (updatedTitle, updatedDate, Id) => {
    try {
      const updatedHoliday = {
        id: Id,
        occasion: updatedTitle,
        date: moment(new Date(updatedDate)).format('YYYY-MM-DD'),
      };
      const response = await updateHolidayById(updatedHoliday);

      if (response.isError === false) {
        // Re-fetch and re-group by year instead of patching in place, since
        // an edited holiday's year may have changed and no longer belongs in
        // the year group it currently sits in.
        await loadData(selectedLocationId);
        dipatchNotification(response.type, response.message);
      } else {
        dipatchNotification('error', response.message);
      }
    } catch (error) {
      dipatchNotification(
        'error',
        'An error occurred while updating the holiday.',
      );
    }
  };

  const deleteHoliday = async (holidayId) => {
    const response = await deleteHolidayById(holidayId);
    if (response.isError === false) {
      const yearIndex = holidaysList.findIndex((yearData) =>
        yearData.data.some((entry) => entry.id === holidayId),
      );

      if (yearIndex !== -1) {
        const updatedList = [...holidaysList];
        updatedList[yearIndex].data = updatedList[yearIndex].data.filter(
          (entry) => entry.id !== holidayId,
        );

        if (updatedList[yearIndex].data.length === 0) {
          updatedList.splice(yearIndex, 1);
        }
        setHolidaysList(updatedList);
      }
    }
    dipatchNotification(response.type, response.message);
  };
  const [isExpanded, setIsExpanded] = useState(new Date().getFullYear());

  const handleChange = (year) => (event, isExpanded) => {
    setIsExpanded(isExpanded ? year : null);
  };

  const [officeLocation, setOfficeLocation] = useState([]);
  const fetchOfficeLocation = async () => {
    setOfficeLocation([]);
    try {
      const response = await _axios.get(`${ADMIN_PATH}/office-location`);
      if (response.status === 200) {
        const activeLocations = response?.data?.data?.filter(
          (location) => location.status === 'ACTIVE',
        );
        setOfficeLocation(activeLocations);
        if (activeLocations.length > 0) {
          setSelectedLocationId(activeLocations[0].id);
          loadData(activeLocations[0].id);
        } else {
          setSelectedLocationId(null);
        }
      }
    } catch (error) {
      console.error('Error fetching office location:', error);
    }
  };

  const handleSelect = (value) => {
    setSelectedLocationId(value);
    loadData(value);
  };

  return (
    <div>
      {loader ? (
        <div>
          <GenericLoader
            rectAttributes={HolidaysComponentLoaderAttribute}
            showError={showError}
            setShowError={setShowError}
          />
          <Fab
            color="primary"
            style={{
              right: 40,
              bottom: 50,
              position: 'fixed',
              zIndex: 1051,
              // the zIndex of edit and delete buttons is 1050
            }}
            onClick={() => {
              setOpen(true);
            }}
          >
            <AddIcon />
          </Fab>
          <DialogBoxComponent
            open={open}
            fullWidth={true}
            maxWidth="md"
            handleClose={handleClose}
            component={
              <AddHoliday
                holidayTitle={holidayTitle}
                setTitle={setTitle}
                date={date}
                setDate={setDate}
                loadData={loadData}
                setOpen={setOpen}
                officeLocation={officeLocation}
                setSelectedLocationId={setSelectedLocationId}
                selectedLocationId={selectedLocationId}
                holidaysList={holidaysList}
                setHolidaysList={setHolidaysList}
                getHolidays={getHolidays}
              />
            }
          />
        </div>
      ) : (
        <>
          {officeLocation.length === 0 ? (
            <Grid
              container
              item
              md={3}
              xs={3}
              sx={{ height: '350px', m: 'auto' }}
            >
              <Typography sx={{ mt: 'auto', mb: 'auto' }}>
                No Office Locations
              </Typography>
            </Grid>
          ) : (
            <div style={{ width: '100%', textAlign: 'right' }}>
              <FormControl
                sx={{ width: '8rem', textAlign: 'left', paddingBottom: '1rem' }}
                size="small"
              >
                <InputLabel id="location-label">Location</InputLabel>
                <Select
                  labelId="location-label"
                  id="location"
                  name="location"
                  value={selectedLocationId}
                  defaultValue={
                    Array.isArray(officeLocation) &&
                    (officeLocation.length > 0 ? officeLocation[0].id : 1)
                  }
                  label="Location"
                  onChange={(event) => handleSelect(event.target.value)}
                >
                  {Array.isArray(officeLocation) &&
                    officeLocation.map((location) => (
                      <MenuItem value={location.id} key={location.id}>
                        {location.locationName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          )}
          <Box className="main-content-overlay">
            {officeLocation.length !== 0 && holidaysList.length === 0 ? (
              <Grid
                container
                item
                md={3}
                xs={3}
                sx={{ height: '350px', m: 'auto' }}
              >
                <Typography sx={{ mt: 'auto', mb: 'auto' }}>
                  No holidays added for this location
                </Typography>
              </Grid>
            ) : (
              <>
                {holidaysList
                  .sort((a, b) => b.year - a.year)
                  .map((data, index) => (
                    <Accordion
                      expanded={isExpanded === data.year}
                      onChange={handleChange(data.year)}
                      key={index}
                      style={{ marginBottom: '10px' }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel1d-content-${index}`}
                        id={index}
                      >
                        <Typography>Year: {data.year}</Typography>
                        <Typography style={{ paddingLeft: '75%' }}>
                          no. of Holidays: {data.data.length}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {data.data.map((holiday, holidayIndex) => (
                          <HolidayCard
                            holidaysList={holidaysList}
                            item={holiday}
                            updateHoliday={updateHoliday}
                            deleteHoliday={deleteHoliday}
                            key={holidayIndex}
                            index={holidayIndex}
                          />
                        ))}
                      </AccordionDetails>
                    </Accordion>
                  ))}
              </>
            )}
            {officeLocation.length !== 0 && (
              <>
                <Fab
                  color="primary"
                  style={{
                    right: 40,
                    bottom: 50,
                    position: 'fixed',
                    zIndex: 1051,
                    // the zIndex of edit and delete buttons is 1050
                  }}
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  <AddIcon />
                </Fab>
                <DialogBoxComponent
                  open={open}
                  fullWidth={true}
                  maxWidth="md"
                  handleClose={handleClose}
                  component={
                    <AddHoliday
                      holidayTitle={holidayTitle}
                      setTitle={setTitle}
                      date={date}
                      setDate={setDate}
                      loadData={loadData}
                      setOpen={setOpen}
                      officeLocation={officeLocation}
                      setSelectedLocationId={setSelectedLocationId}
                      selectedLocationId={selectedLocationId}
                      holidaysList={holidaysList}
                      setHolidaysList={setHolidaysList}
                      getHolidays={getHolidays}
                    />
                  }
                />
              </>
            )}
          </Box>
        </>
      )}
    </div>
  );
}

export default HolidaysComponent;
